import { Chip, ChipProps, TooltipTrigger } from '@toggle/design-system';
import { useTranslation } from 'next-i18next';
import React, { forwardRef } from 'react';

import { TooltipContainer } from '@/components/tooltip-container/TooltipContainer';

export const SingleSearchChip = forwardRef<HTMLButtonElement, ChipProps>(
  (
    { disabled, isActive, onClick, onMouseUp, label, isFocused, ...rest },
    ref
  ) => {
    const { t } = useTranslation('common');

    return (
      <TooltipContainer
        label={t('common:searchChipDisabledTooltip')}
        inPortal
        trigger={[TooltipTrigger.Hover]}
        disabled={!disabled}
      >
        <div>
          <Chip
            ref={ref}
            label={label}
            onMouseUp={onMouseUp}
            onClick={onClick}
            isActive={isActive}
            isFocused={isFocused}
            disabled={disabled}
            variation="outline"
            {...rest}
          />
        </div>
      </TooltipContainer>
    );
  }
);
